// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2510":"6e3891877a3c91e4","3163":"596e4d0fdbd87852","5367":"f02d6a797a2f0b34","6036":"bdf95fb9e346aba9","6958":"923fb6cd79dad6c0","6989":"aceb447463086d74","7974":"9674a23641119427","8163":"8abcbefbba1e2a04"}[chunkId] + ".js";
};